import React from 'react';
import Loader from 'common/components/Loader';

const withLoader = predicate => InnerComponent => props =>
  predicate(props) ? <Loader /> : <InnerComponent {...props} />;

export default withLoader;
